import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';
import { getUserProfileDetail,updateUserProfile } from "../../utils/customerApi";

export default function MyProfile() {
    const [profileData, setProfileData] = useState({
        fname: "",
        lname: "",
        website: "",
        dob: "",
        mobile: "",
        avatar: "",
        professional_role: "",
        plan_id: "",
        prefer_work_with: "",
    });
    const [avatarPreview, setAvatarPreview] = useState(null);
    const [avatarFile, setAvatarFile] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Fetch user profile data
    const fetchProfileData = async () => {
        setIsLoading(true);
        try {
            const result = await getUserProfileDetail();
            if (result && result.data) {
                setProfileData({
                    fname: result.data.fname || "",
                    lname: result.data.lname || "",
                    website: result.data.website || "",
                    dob: result.data.dob || "",
                    mobile: result.data.mobile || "",
                    plan_id: result.data.plan_id || "",
                    professional_role: result.data.professional_role || "",
                    prefer_work_with: result.data.prefer_work_with || "",
                    avatar: result.data.avatar || "",
                });

                // Set avatar preview if exists
                if (result.data.avatar) {
                    setAvatarPreview(result.data.avatar);
                }

                // Update session storage with new email
                sessionStorage.setItem("user_detail", JSON.stringify(result.data));
            }
        } catch (error) {
            toast.error(`${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchProfileData();
    }, []);

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setProfileData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle avatar file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAvatarFile(file);
            setAvatarPreview(URL.createObjectURL(file)); // Show preview
        }
    };

    // Handle profile update
    const handleUpdateProfile = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const formData = new FormData();
            formData.append("fname", profileData.fname);
            formData.append("lname", profileData.lname);
            formData.append("website", profileData.website);
            formData.append("dob", profileData.dob);
            formData.append("mobile", profileData.mobile);
            formData.append("professional_role", profileData.professional_role);
            formData.append("prefer_work_with", profileData.prefer_work_with);

            // Append avatar file if selected
            if (avatarFile) {
                formData.append("avatar", avatarFile);
            }
            //Call Api
            const response = await updateUserProfile(formData);
            //Check if true or not
            if (response.status === true) {
                toast.success(response.message);
                // Fetch Updated Profile Data
                fetchProfileData();
                // Wait for 3 seconds, then refresh the page
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <div className="container-scroller">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />

                        <div className="my-profile-saction">
                            <div className="my-profile-saction-inner">
                            {isLoading ? (
                                <div className="loader-container">
                                    <div className="spinner"></div>
                                    <p>Loading please wait...</p>
                                </div>
                            ) : (
                            <>
                                <h2>Profile</h2>
                                <div className="profile-from">
                                    <form onSubmit={handleUpdateProfile}>
                                        {/* Avatar Upload Section */}
                                        <div className="avatar-upload">
                                            <label>
                                            <div className="icon-image"><i className="fa fa-file-image-o" aria-hidden="true"></i></div>
                                                Upload Profile
                                            <div className="avatar-preview">
                                                {avatarPreview ? (
                                                    <img src={avatarPreview} alt="Avatar Preview" />
                                                ) : (
                                                    <p></p>
                                                )}
                                            </div>
                                            <input type="file" accept="image/*" name="avatar" onChange={handleFileChange} />
                                            </label>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-box-row">
                                                    <label>First Name</label>
                                                    <input type='text' placeholder='First Name' name="fname" value={profileData.fname} onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-box-row">
                                                    <label>Last Name</label>
                                                    <input type='text' placeholder='Last Name' name="lname" value={profileData.lname} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-box-row">
                                                    <label>Website</label>
                                                    <input type='text' placeholder='Website Link' name="website" value={profileData.website} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-box-row">
                                                    <label>Date Of Birth</label>
                                                    <input type='date' placeholder='Date Of Birth' name="dob" value={profileData.dob} onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-box-row">
                                                    <label>Mobile Number</label>
                                                    <input type='phone' placeholder='Mobile Number' name="mobile" value={profileData.mobile} onChange={handleInputChange}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="professional-role">
                                            <h3>Professional Role</h3>
                                            <ul className="pages-list-two">
                                                {[
                                                    { id: "role1", value: "business_owner", label: "I own a business and manage its website." },
                                                    { id: "role2", value: "employee", label: "I’m an employee. I work with our company’s website." },
                                                    { id: "role3", value: "freelancer", label: "I’m a freelancer. I work with my clients’ websites." },
                                                    { id: "role4", value: "agency", label: "I represent an agency. We work with our clients’ websites." },
                                                ].map((option) => (
                                                    <li key={option.id}>
                                                        <div className="form-group">
                                                            <input
                                                                type="radio"
                                                                id={option.id}
                                                                name="professional_role"
                                                                value={option.value}
                                                                checked={profileData.professional_role === option.value}
                                                                onChange={handleInputChange}
                                                            />
                                                            <label htmlFor={option.id}>{option.label}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="button-save"><button type="submit" disabled={isSubmitting}>{isSubmitting ? "Saving..." : "Save"} </button></div>
                                    </form>
                                </div>
                                </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
